import script from "./MobileAccordionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileAccordionItem.vue?vue&type=script&setup=true&lang=ts"

import "./MobileAccordionItem.vue?vue&type=style&index=0&id=ae5b4f6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae5b4f6c"]])

export default __exports__